import HaltEvents from './HaltEvents';

export default HaltEvents;
